import React, { Component } from 'react';

import { Input, } from '../../../../Shared/index';
import PasswordWrapper from '../shared/password_wrapper';
import DemoGuardedButton from '../../shared/demoGuardedButton';

export default class UpdatePassword extends Component {
  state = {
    currentPassword: '',
    newPassword: '',
    showButtonSection: false
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props

    if (!(prevProps.active && !active)) return

    this.reset()
  }

  onCurrentPasswordChange = (e) => this.handleChange('currentPassword', e)

  onNewPasswordChange = (e) => this.handleChange('newPassword', e)

  handleChange = (field, e) => {
    this.setState({ [field]: e.target.value, });
  }

  handleClickCancel = () => {
    const { deactivateSection, } = this.props
    this.reset();
    deactivateSection();
  }

  handleClickChangePassword = (e) => {
    const { showButtonSection, } = this.state
    const { active, activateSection, isBeingPreviewed, } = this.props;
    if (isBeingPreviewed || active || showButtonSection ) { return }

    this.setState({ showButtonSection: true, });
    activateSection();
  }

  handleSubmit = (e) => {
    const { currentPassword, newPassword, } = this.state;
    const { updateUser, role } = this.props;
    const url = role === 'teacher' ? '/teachers/update_my_password' : '/students/update_password';
    e?.preventDefault()
    const data = {
      current_password: currentPassword,
      new_password: newPassword
    };
    updateUser(data, url, 'Settings saved');
  }

  reset = () => {
    this.setState({
      currentPassword: '',
      newPassword: ''
    });
  }

  renderButtonSection = () => {
    const { currentPassword, newPassword, showButtonSection, } = this.state
    if (!showButtonSection) { return }

    const submitButtonClassName = 'quill-button contained green small focus-on-light'

    let submitButton = <input aria-label="Change password" className={`${submitButtonClassName} disabled`} disabled name="commit" type="submit" value="Change password" />

    if (currentPassword.length && newPassword.length) {
      submitButton = <DemoGuardedButton ariaLabel="Change password" className={submitButtonClassName} onClick={this.handleSubmit}>Change password</DemoGuardedButton>
    }

    return (
      <div className="button-section">
        <button className="quill-button outlined grey small focus-on-light" id="cancel" onClick={this.handleClickCancel} type="button">Cancel</button>
        {submitButton}
      </div>
    )
  }

  renderContent = () => {
    const { currentPassword, newPassword, } = this.state
    const { errors, active, timesSubmitted, googleId, cleverId, role,} = this.props;
    const accountType = googleId ? 'Google' : 'Clever';
    const teacherScript = `Before you can create a password, you will need to unlink your ${accountType} account below.`;
    const studentScript = `Your Quill account is linked to ${accountType}. Go to your ${accountType} account settings to change your password.`;
    if (active) {
      return (
        <React.Fragment>
          <form acceptCharset="UTF-8" onSubmit={this.handleSubmit} >
            <div className="fields">
              <div className="current-password-section">
                <PasswordWrapper
                  autoComplete="current-password"
                  className="current-password inspectletIgnore"
                  error={errors.current_password}
                  id="current-password"
                  label="Current password"
                  onChange={this.onCurrentPasswordChange}
                  timesSubmitted={timesSubmitted}
                  value={currentPassword}
                />
                <a className="forgot-password inline-link" href="/password_reset">Forgot password?</a>
              </div>
              <PasswordWrapper
                autoComplete="new-password"
                className="new-password inspectletIgnore"
                error={errors.new_password}
                id="new-password"
                label="New password"
                onChange={this.onNewPasswordChange}
                timesSubmitted={timesSubmitted}
                value={newPassword}
              />
            </div>
          </form>
          {this.renderButtonSection()}
        </React.Fragment>
      )
    } else if (googleId || cleverId) {
      return (
        <p className="external-provider-password">{role === 'teacher' ? teacherScript : studentScript}</p>
      )
    } else {
      return (
        <div className="inactive-password-container">
          <Input
            className="not-a-password"
            disabled={true}
            id="password"
            label="Password"
            type="password"
            value="notapassword"
          />
          <DemoGuardedButton className="quill-button outlined green small change-password focus-on-light" onClick={this.handleClickChangePassword}>Change password</DemoGuardedButton>
        </div>
      )
    }
  }

  render() {
    return (
      <section aria-labelledby="passwordTitle" className="user-account-password user-account-section">
        <h1 id="passwordTitle">Password</h1>
        {this.renderContent()}
      </section>
    )
  }
}
